package com.tregz.polyglot.io.cloud

@JsModule("firebase/app")
@JsNonModule
external object FirebaseApp {
    val initializeApp: (config: dynamic) -> dynamic
    val getApps: () -> Array<dynamic>
}

private var initialized = false

internal actual fun ensureFirebaseInitialized() {
    if (initialized) return
    try {
        // Other named apps (e.g. Tremenz's) may share the SDK; only the default one is Polyglot's
        if (FirebaseApp.getApps().none { it.name == "[DEFAULT]" }) {
            val config = js("{}")
            config.apiKey = "AIzaSyBCXLr5NA63YrYBVXeppvdOP5ubmg13wbY"
            config.authDomain = "tregz-web.firebaseapp.com"
            config.projectId = "tregz-web"
            config.storageBucket = "tregz-web.appspot.com"
            config.messagingSenderId = "601275890536"
            config.appId = "1:601275890536:web:60764bf061be93fd15b4dd"
            config.measurementId = "G-FH6TGREMEB"
            FirebaseApp.initializeApp(config)
            println("[Polyglot] Initialized Firebase web app successfully")
        }
        initialized = true
    } catch (ex: Throwable) {
        println("[Polyglot] Firebase web init error: ${ex.message}")
    }
}
